import type { InvoiceUpdate, InvoiceCreation } from "~/types/apps/invoiceType";
import { useInvoiceStore } from "~/stores/apps/invoice";
import { useEcomStore } from "~/stores/apps/eCommerce";
import { useThirdpartyStore } from "~/stores/apps/thirdparty";

export function checkoutMixin() {
    const createUpdateInvoice = async (discount_card = false) => {
        const products = useEcomStore().getCart.map((x: any) => {
            let offer_price = x.offer_price ?? x.price;
            let type_discount_applied = x.offer_type;
            if (discount_card && x.discount_card > 0) {
                let offer_price_discount_card = Math.round(
                    parseFloat(x.price) * (1 - x.discount_card / 100),
                );
                if (offer_price_discount_card <= offer_price) {
                    offer_price = offer_price_discount_card;
                    type_discount_applied = "discount_card";
                }
            }
            return {
                id: x.id,
                ean: x.ean,
                readed_code: x.ean,
                name: x.name,
                qty: x.qty,
                price: x.price,
                net_price: offer_price * x.qty,
                tax: x.iva,
                unit: x.und,
                price_discount:
                    type_discount_applied == "price_discount"
                        ? x.price_discount
                        : 0,
                price_discount_total:
                    type_discount_applied == "price_discount"
                        ? x.price_discount * x.qty
                        : 0,
                discount:
                    x.promo_discount > 0
                        ? x.promo_discount
                        : type_discount_applied == "discount"
                          ? x.discount
                          : 0,
                discount_card:
                    type_discount_applied == "discount_card"
                        ? x.discount_card
                        : 0,
                discount_percent: 0, // Se debe validar como obtener el descuento en porcentaje
            };
        });
        let totals = { ...useEcomStore().getTotals };
        let timers = { ...(await useEcomStore().getTimers()) };

        if (!discount_card) {
            totals.discount_card = 0;
        } else if (totals.total && totals.discount_card) {
            totals.total = totals.total - totals.discount_card;
        }

        if (useInvoiceStore().invoiceId) {
            // update
            try {
                let payload: InvoiceUpdate = {
                    products: products,
                    thirdparty: useThirdpartyStore().thirdparty?.id ?? 1,
                    store: 1, // TODO: Tienda variable al guardar
                    totals: totals,
                    metadata: {
                        has_restriction: useEcomStore().hasRestriction,
                        has_price_restriction:
                            useEcomStore().hasPriceRestriction,
                        ...timers,
                    },
                };
                if (
                    Object.keys(useInvoiceStore().appliedPromotions).length > 0
                ) {
                    console.log(
                        ">> apliedPromotions added to payload: ",
                        useInvoiceStore().appliedPromotions,
                    );
                    payload.applied_promotions =
                        useInvoiceStore().appliedPromotions;
                }
                await useInvoiceStore().updateInvoice(payload);
            } catch (e) {
                console.log(e);
            }
        } else {
            // create
            try {
                let payload: InvoiceCreation = {
                    thirdparty: useThirdpartyStore().thirdparty?.id ?? 1,
                    store: 1, // TODO: Tienda variable al guardar
                    products: products,
                    totals: totals,
                    metadata: {
                        has_restriction: useEcomStore().hasRestriction,
                        has_price_restriction:
                            useEcomStore().hasPriceRestriction,
                        ...timers,
                    },
                };
                await useInvoiceStore().createInvoice(payload);
            } catch (e) {
                console.log(e);
            }
        }
    };
    return { createUpdateInvoice };
}
